import { isFeatureAccessDenied } from '../utils/isFeatureAccessDenied'
import { throwOnMovedOutWriteAccessDenied } from './throwOnMovedOutWriteAccessDenied'

export const throwOnAccessDenied = (error: unknown): boolean =>
  isFeatureAccessDenied(error) || throwOnMovedOutWriteAccessDenied(error)
